import React, { FC } from 'react';
import { RecommendationsList } from '../../components/RecommendationsList';
import { InitialProps } from '../../../lib/types';

const App: FC<InitialProps> = ({ matchmakingList, userData = {}, displayMode, currency, matchmakingNotes }) => {
    const username = userData?.username;

    return (
        <RecommendationsList
            matchmakingList={matchmakingList}
            username={username}
            displayMode={displayMode}
            currency={currency}
            matchmakingNotes={matchmakingNotes}
        />
    );
};

export default App;
